import React from 'react';
import { Text, TextProps, Linking, Platform } from 'react-native';
import useStyles from './Link.styles';

export type LinkProps = TextProps & {
  href?: string;
};

export const Link: React.FC<LinkProps> = ({ children, style, href, onPress, ...props }) => {
  const s = useStyles();

  return (
    <Text
      // @ts-ignore
      href={href}
      style={[s.root, style]}
      onPress={
        onPress
          ? onPress
          : Platform.OS !== 'web' && href
          ? () => {
              Linking.openURL(href);
            }
          : undefined
      }
      accessibilityRole="link"
      {...props}
    >
      {children}
    </Text>
  );
};
